import { createTheme } from "@mui/material/styles";

import { presetPalettes } from "@ant-design/colors";

import { PaletteMode } from "@mui/material";
import ThemeOption from "./theme";

const Palette = (mode: PaletteMode) => {
  const isDarkMode = mode === "dark";

  const colors = presetPalettes;

  const greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"];
  const greyConstant = [isDarkMode ? "#121212" : "#fafafb", "#e6ebf1"];

  // ff0000
  const greyPrimary = [
    isDarkMode ? "#1e1e1e" : "#ffffff", // color paper
    isDarkMode ? "#fff" : "#000", // color text area
    isDarkMode ? "#1e1e1e" : "#f5f5f5", // burger navigation
    isDarkMode ? "#ffffff0d" : "#f0f0f0", // divider
    isDarkMode ? "#ffffff0d" : "#d9d9d9", // border input
    "#bfbfbf",
    "#8c8c8c",
    isDarkMode ? "#f0f0f0" : "#595959", // color input
    isDarkMode ? "#ffffffde" : "#262626", // color text
    "#141414",
    "#000000",
  ];

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors);

  return createTheme({
    palette: {
      mode,
      common: {
        black: "#000",
        white: "#fff",
      },
      ...paletteColor,
      text: {
        primary: paletteColor.grey[700],
        secondary: paletteColor.grey[500],
        disabled: paletteColor.grey[400],
      },
      action: {
        disabled: paletteColor.grey[300],
      },
      divider: paletteColor.grey[200],
      background: {
        paper: paletteColor.grey[0],
        default: paletteColor.grey.A50,
      },
    },
  });
};

export default Palette;
